import { useState, useCallback } from 'react';

import {
  Parameter$postReservationFlowProductVerify,
  RequestBody$postReservationFlowProductVerify,
} from '../../../../openapi/generated/apiClient';
import {
  isAxiosError,
  useClientSideApiClient,
} from '../../../../openapi/axiosClient';
import { fetchCsrfToken } from '../../../../infrastructure/api';

export interface UseVerifyReservationFlowProductParams {
  parameter: Omit<Parameter$postReservationFlowProductVerify, 'X-Csrf-Token'>;
}

export interface UseVerifyReservationFlowProductValue {
  isValidating: boolean;
  verifyReservationFlowProduct: (params: {
    values: RequestBody$postReservationFlowProductVerify['application/json'];
  }) => Promise<{} | { error: { message: string } }>;
}

export const useVerifyReservationFlowProduct: (
  params: UseVerifyReservationFlowProductParams,
) => UseVerifyReservationFlowProductValue = ({ parameter }) => {
  const apiClient = useClientSideApiClient();
  const [isValidating, setIsValidating] = useState(false);

  const verifyReservationFlowProduct = useCallback<
    UseVerifyReservationFlowProductValue['verifyReservationFlowProduct']
  >(
    async ({ values }) => {
      setIsValidating(true);

      try {
        const csrfToken = await fetchCsrfToken();

        await apiClient.postReservationFlowProductVerify({
          parameter: { ...parameter, 'X-Csrf-Token': csrfToken },
          requestBody: values,
        });

        setIsValidating(false);
        return {};
      } catch (error) {
        if (!isAxiosError(error) || typeof error.response === 'undefined') {
          setIsValidating(false);
          return { error: { message: '予期せぬエラーが発生しました' } };
        }

        const message =
          error.response.status === 401
            ? 'パスワードが違います。正しいパスワードを入力してください。'
            : '予期せぬエラーが発生しました';

        setIsValidating(false);
        return { error: { message } };
      }
    },
    [parameter, apiClient],
  );

  return { isValidating, verifyReservationFlowProduct };
};
